module.exports = __webpack_public_path__ + "img/031-activity.42ff8be5.svg";